import { render, staticRenderFns } from "./EditNewsletterView.vue?vue&type=template&id=77a8b4e8"
import script from "./EditNewsletterView.vue?vue&type=script&lang=js"
export * from "./EditNewsletterView.vue?vue&type=script&lang=js"
import style0 from "./EditNewsletterView.vue?vue&type=style&index=0&id=77a8b4e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports